import SavedCards from './SavedCards';

export default SavedCards;
